export const VIEWS = {
  ALL: 'all',
  MY_CASES: 'my-cases',
  TASKS: 'tasks',
  MY_TASKS: 'my-tasks',
  WILL_DRAFTING: 'drafting',
} as const

export type View = (typeof VIEWS)[keyof typeof VIEWS]
